const extractAndParseDiscountBxgyJson = (htmlString) => {
    try {
        // Use regex to extract JSON inside the <div data-discounts-bxgy>...</div>
        const match = htmlString.match(/<div data-discounts-bxgy>(.*?)<\/div>/s);
        
        if (!match || match.length < 2) {
            return null;
        }

        // Clean up any escaped characters and parse the JSON
        const jsonString = match[1]
            .replace(/&quot;/g, '"') // Convert HTML-encoded quotes
            .replace(/\r?\n/g, '')   // Remove new lines
            .trim();                 // Trim unnecessary spaces
        
        return JSON.parse(jsonString); // Parse and return the JSON
    } catch (error) {
        console.error("Error parsing JSON:", error);
        return null; // Return null if parsing fails
    }
}

const addProductDiscount = async (url, quantity = 1, discountTitle, variantTitle) => {
  try {
    // Fetch the HTML
    let response = await fetch(url);
    let htmlText = await response.text();

    // Parse the HTML
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlText, "text/html");

    // Find the product form
    let form = doc.querySelector('.js-product-form');
    if (!form) {
        console.warn("addProductDiscount - Product form not found.");
        // const errors = document.getElementById('cart-errors');
        // errors.textContent = theme.strings.cartError;
        // errors.hidden = false;
        const modal = document.getElementById("automatic-discount-bxgy-modal");

        if (modal) {
            const modalContent = modal.querySelector('.modal__content');
            if (modalContent) {
                modalContent.innerHTML = `${discountTitle} ${window.theme.strings.automaticDiscountBxgyErrorMssage} (${variantTitle})`
                modal.open();   
            }
        }
        return;
    }

    // Append the form to the current document (so event listeners in <product-form> are active)
    let productFormComponent = document.createElement('product-form');
    productFormComponent.innerHTML = form.outerHTML;
    document.body.appendChild(productFormComponent);

    // Find the newly added form
    let newProductForm = productFormComponent.querySelector('.js-product-form');
    if (newProductForm) {
      // Manually initialize this specific product-form (call init)
      if (!productFormComponent._initialized) {
        productFormComponent.init();
        productFormComponent._initialized = true; // Prevent reinitializing
      }
    }

    // Set quantity value before submission
    let quantityInput = newProductForm.querySelector('input[name="quantity"]');
    if (quantityInput) {
        quantityInput.value = quantity;
    } else {
        console.warn("addProductDiscount - Quantity input not found in the form.");
    }

    // Submit the form
    newProductForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    // console.log(`addProductDiscount - Form submitted with quantity: ${quantity}`);
  } catch (error) {
      console.error("addProductDiscount - Error fetching or submitting the form:", error);
  }
}

const checkDiscountBxGyEligibility = async (event) => {
    try {
      const discountEligibilityResponse = await fetch(`${theme.routes.cart}?sections=automatic-discount-bxgy-eligibility-api`);
      if (!discountEligibilityResponse.ok) throw new Error('Fetch failed');
      
      const discountEligibility = await discountEligibilityResponse.json();
      const discountData = discountEligibility['automatic-discount-bxgy-eligibility-api'];
      
      if (discountData?.includes('data-discounts-bxgy')) {
        const parsedDiscounts = extractAndParseDiscountBxgyJson(discountData);
        // console.log('Discounts:', parsedDiscounts);
        const checkoutButtons = document.querySelectorAll('button[name="checkout"]')
        checkoutButtons?.forEach(button => {
            button.disabled = true;
        });
        // Process discounts sequentially
        for (const discount of parsedDiscounts ?? []) {
          if (discount.variantsJson?.length) {
            const variant = discount.variantsJson[0];
            if (event.detail.variantId === Number(variant.id)) {
                continue;
            }
            const url = variant.url.replace(/(section_id=)([^&]*)/, `$1automatic-discount-bxgy-product-api`);
            await addProductDiscount(url, discount.quantity, discount.discountTitle, variant.title);
          }
        }
        checkoutButtons?.forEach(button => {
            button.disabled = false;
        });
      }
    } catch (error) {
      console.error('Error:', error); // Add detailed logging
    }
  };

document.addEventListener('on:cart:add', checkDiscountBxGyEligibility);
document.addEventListener('on:line-item:change', checkDiscountBxGyEligibility);

console.log('automatic_discount_bxgy_handler loaded !');